import { render } from "./MenuSettingsItem.vue?vue&type=template&id=2c5afd36&scoped=true&ts=true&lang=pug"
import script from "./MenuSettingsItem.vue?vue&type=script&lang=ts"
export * from "./MenuSettingsItem.vue?vue&type=script&lang=ts"

import "./MenuSettingsItem.vue?vue&type=style&index=0&id=2c5afd36&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5afd36"]])

export default __exports__